const f = {
  color: {
    background: "#ffffffff"
  }
};
export {
  f as scrollable
};
